import type { RecentTransaction, RecentTransactionType } from './DashboardContext';

export type RecentReportKind =
	| 'sale'
	| 'movement'
	| 'supply'
	| 'conversion'
	| 'production'
	| 'bom'
	| 'wallet'
	| 'expense'
	| 'voucher'
	| 'deposit';

const TYPE_TO_REPORT: Record<RecentTransactionType, RecentReportKind> = {
	sale: 'sale',
	payment: 'sale',
	supply: 'supply',
	supply_return: 'supply',
	supply_payment: 'supply',
	movement: 'movement',
	discard: 'movement',
	restore: 'movement',
	inventory: 'movement',
	conversion: 'conversion',
	production: 'production',
	bom: 'bom',
	wallet: 'wallet',
	expense: 'expense',
	voucher: 'voucher',
	deposit: 'deposit',
};

export const toRecentReportBundle = (tx: RecentTransaction) => ({
	...tx,
	batch: tx.batch || tx.id,
	id: tx.type === 'bom' ? Number(tx.id) : tx.id,
	client_id: tx.clientId ?? Number(tx.batch || tx.id),
	client: tx.clientName || tx.description,
	count: Number(tx.count || 0),
});

export const resolveRecentReportKind = (tx: RecentTransaction): RecentReportKind =>
	TYPE_TO_REPORT[tx.type] || 'movement';

export const hasRecentReportReference = (tx: RecentTransaction) =>
	!!String(tx.batch || tx.id || tx.reference || '').trim();

export const isVoucherBatchReport = (tx: { type?: string; batch?: string; count?: number }) =>
	tx.type === 'voucher'
	&& Number(tx.count || 0) > 1
	&& String(tx.batch || '').trim() !== '';
